import React from 'react';

import { useDialog } from 'components/v2/FormElements/Dialog';
import ConfirmModal from 'components/v2/FormElements/ConfirmModal';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import Avatar from 'components/v2/PageElements/Avatar';

const CellBoxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

const CellButton = styled(Button)(({ theme }) => ({
  justifyContent: 'flex-start',
  minWidth: '100%',
  color: theme.palette.primary.main,
}));

export const avatarCellRender = ({ row }) => {
  return <Avatar profile={row} />;
};

export const comboCellRender = (prop) => {
  return ({ row }) => {
    const items = row[prop]?.filter(Boolean) || [];
    return (
      <CellBoxContainer>
        {items.map((item, index) => {
          return (
            <Typography
              key={index}
              variant={index === 0 ? 'body2' : 'caption'}
              color={index === 0 ? 'text.primary' : 'text.secondary'}
            >
              {item}
            </Typography>
          );
        })}
      </CellBoxContainer>
    );
  };
};

export const buttonCellRender = (prop, { onClick, getUrl, history }) => {
  return ({ row }) => {
    const handleClick = (event) => {
      if (onClick) {
        return onClick(row, event);
      }

      // If getUrl is provided and modifier key is pressed, open in new tab
      if (getUrl) {
        const url = getUrl(row);
        if (event.ctrlKey || event.metaKey) {
          window.open(url, '_blank');
        } else {
          history?.push(url);
        }
      }
    };

    const handleMouseDown = (event) => {
      // middle click
      if (event.button === 1 && getUrl) {
        event.preventDefault();
        window.open(getUrl(row), '_blank', 'noopener,noreferrer');
      }
    };

    return (
      <CellButton onClick={handleClick} variant="text" onMouseDown={handleMouseDown}>
        {row[prop]}
      </CellButton>
    );
  };
};

const DeleteButton = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.text.disabled : 'inherit',
  '&:hover': {
    color: theme.palette.error.main,
  },
}));

const DeleteModal = ({
  action = 'Delete',
  afterDelete,
  confirmText,
  destroy,
  list,
  nameProp,
  row,
  type = 'item',
  ...rest
}) => {
  const { onClick, onClose, open } = useDialog();

  const onDelete = async () => {
    if (!row || !row.id) return;
    const resp = await destroy(row.id);
    if (!resp.success) return;
    afterDelete && afterDelete();
    onClose();
  };

  const name = nameProp && row ? `${row[nameProp]} ${type}` : 'row';
  const message = `Are you sure you want to ${action.toLowerCase()} the ${name}?`;

  const modalProps = {
    title: name ? `${action} ${name}` : action,
    isOpen: open,
    onConfirm: onDelete,
    confirmText,
    onClose,
    message,
  };

  return (
    <>
      <ConfirmModal {...modalProps} />
      <IconButton onClick={onClick}>
        <DeleteButton />
      </IconButton>
    </>
  );
};

export const deleteCell = (props) => {
  return ({ row }) => <DeleteModal {...props} row={row} />;
};
